module.exports = __webpack_public_path__ + "img/contenedor10.f35ec97c.png";